var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m18.7142 15.6436c-3.2135-.0035-5.3779-1.1241-5.9396-3.0755-.4083-1.4181.1658-3.38774 1.6597-3.46025 1.6118.10566 1.6487 1.89565 1.5948 3.29215-.0199.5196-.0318.8331.0756 1.0631.1227.2617.3959.3878.6988.3228.6998-.1521 1.9986-1.6722 2.0078-3.4376.0134-2.63688-2.1424-4.49788-5.2434-4.52573-.0247-.00016-.0489-.0003-.074-.0003-3.71548.00002-7.48488 2.50873-8.4595 7.35843-.26233 2.2016.41958 5.2461 4.71139 5.2461.35371 0 .66521.0073.93771.0213h4.0284c-.0049-.0072-.0096-.0143-.0143-.0213.1071.0089.2196.0162.3363.0213h.826c1.7533-.0783 3.7625-.6845 2.8892-2.7222-.012-.0281-.0236-.0555-.0349-.0823zm-9.40707 1.8697c-1.33084-2.2688-.85739-4.9366.81987-6.698-1.20361 2.3057-.58292 5.2342 1.4279 6.698z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.5aca15906a687a598da730537bbca464.svg";
export { ForwardRef as ReactComponent };